import React from "react"
import { Bell, Bookmark, Building, Calendar, CreditCard, Group, MessageCircle, Search, Target, UserPlus, Zap } from "lucide-react"

export function EntrenarSection() {
  return (
    <section id="entrenar" className="py-8 md:py-16 bg-gradient-to-br from-orange-50 to-amber-100 px-4 relative overflow-hidden">
      <div className="container">
        <div className="text-center mb-6">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold font-display mb-3">
            Organiza tu agenda de entrenamiento
          </h2>
          <div className="inline-block bg-[#EA580C] text-white rounded-full px-4 py-2 text-sm sm:text-base font-bold mb-3">
            ¡ ENTRENA MAS JUGADORES ! 🏋️‍♂️🎾🏀
          </div>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="mb-3 text-lg font-bold font-display">Para Entrenadores</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <UserPlus className="h-4 w-4 text-[#EA580C]" />
                <span>Arma tu perfil deportivo y comparti tu disponibilidad</span>
              </li>
              <li className="flex items-center gap-2">
                <Group className="h-4 w-4 text-[#EA580C]" />
                <span>Arma tu grupo de jugadores</span>
              </li>
              <li className="flex items-center gap-2">
                <CreditCard className="h-4 w-4 text-[#EA580C]" />
                <span>Toma reservas y cobra tus clases al toque!</span>
              </li>
              <li className="flex items-center gap-2">
                <Bell className="h-4 w-4 text-[#EA580C]" />
                <span>
                  <strong>¿ Te Cancelaron ? </strong> Alerta relampago!
                </span>
              </li>
            </ul>
          </div>
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="text-lg font-bold font-display mb-3">Tus beneficios</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Calendar className="h-4 w-4 text-[#EA580C]" />
                <span>Tu espacio de reservas en linea</span>
              </li>
              <li className="flex items-center gap-2">
                <Target className="h-4 w-4 text-[#EA580C]" />
                <span>Aumenta tu visibilidad y clientela</span>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4 text-[#EA580C]" />
                <span>Comunicate con tu grupo, promociona eventos y publica!</span>
              </li>
              <li className="flex items-center gap-2">
                <Building className="h-4 w-4 text-[#EA580C]" />
                <span>Unite a tus clubes e invitalos a participar!</span>
              </li>
            </ul>
          </div>
          <div className="rounded-2xl border border-orange-100 bg-white/80 backdrop-blur-sm p-4 text-card-foreground shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <h3 className="text-lg font-bold font-display mb-3">Para Jugadores</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Search className="h-4 w-4 text-[#EA580C]" />
                <span>Encuentra entrenadores calificados</span>
              </li>
              <li className="flex items-center gap-2">
                <Bookmark className="h-4 w-4 text-[#EA580C]" />
                <span>Reserva clases individuales o grupales</span>
              </li>
              <li className="flex items-center gap-2">
                <Zap className="h-4 w-4 text-[#EA580C]" />
                <span>Mejora tu técnica y rendimiento</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
